import React from 'react';

export interface BaseImageProps {
  src: string;
  alt: string; // making 'alt' property required
}

export type ImageProps = BaseImageProps & React.ImgHTMLAttributes<HTMLImageElement>;

const Image: React.FC<ImageProps> = (props) => {
  const { alt, ...rest } = props;

  return <img {...rest} alt={alt} />;
};

export { Image };
